// eslint-disable-next-line
export enum mfaFlow {
  MFA = "mfa",
  SECURITY = "security",
}
